<template>
  <div :style="shimmingLineStyle" class="shimming-line">
    <ContentLoader
      :width="width"
      :height="height"
      :speed="1"
      :primaryColor="primaryColor"
      :secondaryColor="secondaryColor">
      <rect x="0" y="0" :rx="radiusTopBottom" :ry="radiusLeftRight" :width="width" :height="height" />
    </ContentLoader>
  </div>
</template>

<script>

import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'ShimmingLessonCell',
  components: {
    ContentLoader,
  },
  props: {
    width: {
      type: Number,
      required: false,
      default: 50,
    },
    height: {
      type: Number,
      required: false,
      default: 17,
    },
    radiusLeftRight: {
      type: Number,
      required: false,
      default: 0,
    },
    radiusTopBottom: {
      type: Number,
      required: false,
      default: 0,
    },
    primaryColor: {
      type: String,
      required: false,
      default: '#dadada',
    },
    secondaryColor: {
      type: String,
      required: false,
      default: '#cecece',
    },
  },
  computed: {
    shimmingLineStyle() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
      };
    },
  },
};
</script>


<style lang="scss" scoped>
  .shimming-line {
    display: inline-block;
    svg {
      display: inline-block;
      vertical-align: top;
    }
  }
</style>
